import { t } from 'i18next';

import { oldContactsPath } from 'contacts/routes/routePaths';
import { AccessPermissions } from 'core/enums';
import { Icon } from 'coreOld/elements';
import { INavItem } from 'coreOld/types';
import { goTo } from 'coreOld/utils';
import {
  companyPartsPath,
  oldCompanyConfiguratorsPath,
  oldCompanyElementsPath,
  oldConfiguratorsPath,
  oldElementsPath,
  oldManufacturersPath,
  oldPartsPath,
} from 'partsOld/routes/routePaths';
import { costingProfileListPath, pricingProfileListPath } from 'pricing/routes/routePaths';

export const navBrowseStructure = (hiddenOnSmall = false): INavItem[] => [
  {
    name: t('labelAllParts'),
    onClick: () => goTo(oldPartsPath()),
    hiddenOnSmall,
  },
  {
    name: t('labelAllManufacturers'),
    onClick: () => goTo(oldManufacturersPath()),
    hiddenOnSmall,
  },
  {
    name: t('labelAllConfigurators'),
    onClick: () => goTo(oldConfiguratorsPath()),
    hiddenOnSmall,
  },
  {
    name: t('labelAllElements'),
    onClick: () => goTo(oldElementsPath()),
    hiddenOnSmall,
  },
];

export const navPricingProfileStructure = (hiddenOnSmall = false): INavItem[] => [
  {
    name: t('labelPricingProfiles'),
    url: pricingProfileListPath(),
    hiddenOnSmall,
  },
  {
    name: t('labelCostingProfiles'),
    url: costingProfileListPath(),
    hiddenOnSmall,
  },
];

export const navCompanyStructure = (hiddenOnSmall = false): INavItem[] => [
  {
    name: t('labelCompanyParts'),
    url: companyPartsPath(),
    hiddenOnSmall,
    permissions: [AccessPermissions.COMPANY_PARTS],
  },
  {
    name: t('labelCompanyConfigurators'),
    onClick: () => goTo(oldCompanyConfiguratorsPath()),
    hiddenOnSmall,
  },
  {
    name: t('labelCompanyElements'),
    onClick: () => goTo(oldCompanyElementsPath()),
    hiddenOnSmall,
  },
];

export const navUsersStructure = (hiddenOnSmall = false): INavItem[] => [
  {
    name: t('labelContacts'),
    onClick: () => goTo(oldContactsPath()),
    hiddenOnSmall,
  },
];

export const navStructure = (): INavItem[] => [
  {
    onClick: () => goTo(oldContactsPath()),
    icon: <Icon name={Icon.USERS} />,
  },
];
